import React, { Component } from 'react';
import styled from 'styled-components';

import { Font, FontWeight } from '../../utils/fonts';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import Color from '../../utils/colors';

import Analytics from '../../services/Analytics';

class ContactsBlock extends Component {
    static handleFaceBookClick() {
        Analytics.sendEvent('go to facebook from "свяжитесь с нами" block');
    }

    static handlePhoneClick() {
        Analytics.sendEvent('click to phone from "свяжитесь с нами" block');
    }

    render() {
        const { className } = this.props;

        const email = 'hello@aventica.ru';
        const phone = '8 (499) 653-50-67';
        const facebook = 'facebook.com/Aventicalab';

        return (
            <Root className={className}>
                <Wrapper>
                    <ContactHeadline>
                        E-mail
                    </ContactHeadline>
                    <Email href="mailto:hello@aventica.ru" target="blank">
                        {email}
                    </Email>
                </Wrapper>
                <Wrapper>
                    <ContactHeadline>
                        Телефон
                    </ContactHeadline>
                    <Phone href="tel:+74996535067" target="blank" onClick={ContactsBlock.handlePhoneClick}>
                        {phone}
                    </Phone>
                </Wrapper>
                <Wrapper>
                    <ContactHeadline>
                        Facebook
                    </ContactHeadline>
                    <Facebook href="https://www.facebook.com/Aventicalab" target="blank" onClick={ContactsBlock.handleFaceBookClick}>
                        {facebook}
                    </Facebook>
                </Wrapper>
            </Root>
        );
    }
}

const Root = styled.div``;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;

    margin-bottom: 40px;

    &:last-child {
            margin-bottom: 0px;
        }

    ${mediaWidth.m} {
        margin-bottom: 56px;

    }
`;

const ContactHeadline = styled.div`
    ${Font.PRIMARY};
    ${FontWeight.REGULAR};
    font-size: 16px;
    line-height: 21px;
    color: rgba(0, 0, 0, .4);

    margin-bottom: 8px;

    ${mediaWidth.m} {
        font-size: 18px;
        line-height: 23px;

        margin-bottom: 16px;
    }
`;

const Contact = styled.a`
    ${Font.PRIMARY};
    ${FontWeight.REGULAR};
    text-decoration: none;
    font-size: 24px;
    line-height: 32px;
    color: #000000;

    cursor: pointer;

    ${mediaWidth.l} {
        font-size: 32px;
        line-height: 40px;

        :hover {
            color: ${Color.SECONDARY};
        }

        :active {
            color: #002679;
        }
    }
`;

const Email = styled(Contact)``;

const Phone = styled(Contact)``;

const Facebook = styled(Contact)``;

export default ContactsBlock;
